
import React, { useEffect, useState } from 'react';
import {Row, Col, Tabs} from 'antd'

import {TabEstoqueComercial} from './tab-estoque-comercial';
import { TabEstoqueTributario } from './tab-estoque-tributario';
import { useSelector } from 'react-redux';
import { useFieldTabIdentifier } from '../../useFieldTabIdentifier';

const {TabPane} = Tabs;

const TabEstoque = (props)=>{

    const { identifyField } = useFieldTabIdentifier();
    const {firstErrorField} = useSelector(state=>state.produto);

    let [activeKey, setActiveKey] = useState("estoqueComercial");

    
    useEffect(() => {
        const {tab, innerTabLevel1} = identifyField(firstErrorField);

        if(tab && tab=="estoque"){
            setActiveKey(innerTabLevel1);
        }
     

    }, [firstErrorField]);
    



    return <Row gutter={[16, 16]}>
                <Col sm={24}>
                    <Tabs size="small" type="card" activeKey={activeKey} onChange={evt => setActiveKey(evt)}>
                        
                        <TabPane tab="Comercial" key="estoqueComercial">
                            <TabEstoqueComercial {...props} innerTabLevel1={"estoqueComercial"}></TabEstoqueComercial>
                        </TabPane>

                        <TabPane tab="Tributario" key="estoqueTributário">
                            <TabEstoqueTributario {...props} innerTabLevel1={"estoqueTributario"}></TabEstoqueTributario>
                        </TabPane>

                    </Tabs>
                </Col>
            </Row>
}

export {TabEstoque}
